import * as api from "@/api";
import * as signals from "@/signals";
import { NoteResponse } from "@/types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

function useNotes(): UseQueryResult<NoteResponse | undefined> {
	return useQuery({
		queryFn: () => {
			if (!signals.login.value.username) {
				return null;
			}
			return api.getNotes();
		},
		queryKey: ["notes", signals.login.value.username],
	});
}

export default useNotes;
